import * as Cookie from 'common-cookie/src';

import { isBrowser } from './device';
import { getCookieDomain } from './host';

const COOKIE_EXPIRES = 30;

export default {
  ...Cookie,
  set: (key, value, options) => {
    if (isBrowser()) {
      window.sessionStorage.setItem(key, value);
    }
    return Cookie.set(key, value, {
      expires: COOKIE_EXPIRES,
      domain: getCookieDomain(),
      path: '/',
      ...options,
    });
  },
  get: (key) => {
    let ret = '';
    if (isBrowser()) {
      ret = window.sessionStorage.getItem(key);
    }
    return ret || Cookie.get(key);
  },
  remove: (key, options) => {
    if (isBrowser()) {
      window.sessionStorage.removeItem(key);
    }
    return Cookie.remove(key, {
      expires: COOKIE_EXPIRES,
      domain: getCookieDomain(),
      path: '/',
      ...options,
    });
  },
};
